'use client';

import { createPage } from '@/app/_shared/utils/dynamicImports';
const New = createPage(() => import('@/features/discover/components/New'));

export default function NewPage() {
	return <New />;
}
